@let cmsText = 'renew_legacy' | translate:{ oldPlan: oldPlan, newPlan: newPlan };
<ng-container *ngIf="(sharedNavEnabled | async) === 'true'">
  <div webu-shared-nav-scroll id="gbSharedNav" style="position: fixed; z-index: 123; transition: top 0.35s ease">
    <webu-shared-nav-wrapper [isAuthenticated]="authenticationStatus === 'authenticated'"></webu-shared-nav-wrapper>
  </div>
</ng-container>
<ng-container>
  <div class="header-white" *ngIf="authenticationStatus === 'authenticated'" autoscroll="true">
    <div class="container">
      <div class="row">
        <div class="col">
          <webu-vehicle-switcher class="cit2-page-heading mt-10"></webu-vehicle-switcher>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="loading && !isError"><img alt="Loading" aria-hidden="true" class="img-fluid centerFix"
      role="presentation"
      [src]="'/ownercenter/content/dam/gmownercenter/gmna/static/siteImages/icons/loading_animation_v3.gif' | link" /></ng-container>
  <div *ngIf="!loading && isError" autoscroll="true">
    <error-state-gm-web-shop (reloadPdp)="refresh()" [errorText1]="'PDP_ERROR_TXT_1' | translate"
      [errorText2]="'PDP_ERROR_TXT_2' | translate" [errorText3]="'PDP_ERROR_TXT_3' | translate"
      [errorText4]="'PDP_ERROR_TXT_4' | translate"
      [alertAltTxt]="'PDP_ALERT_ALT_TXT' | translate"></error-state-gm-web-shop>
  </div>
  <ng-container *ngIf="!loading && !isError && isCVOVehicle">
    <div class="pt-15 pb-15 container">
      <ox-alert type="caution" [whiteBackground]="true">
        <span class="gb-body1" [translate]="'cvo_vehicle_error_message'"></span>
        <a class="gb-body1 heavy d-inline" href="tel:{{'onstar_phone_number' | translate}}" [translate]="'onstar_phone_number_text'"></a>
      </ox-alert>
    </div>
  </ng-container>
  <ng-container *ngIf="!loading && !isError" autoscroll="true" >
    <div contentOffset class="page-container header-white main-content">
      <web-shop-unauth-error-sticky *ngIf="(userState$ | async) !== 'authenticated'" theme="{{ bml.brand }}" [stickyPricingData]="pricingData"
        (logInInstance)="signIn()" [unauthSignInLnk]="'PDP_UNAUTH_SIGN_IN_LNK' | translate"
        [unauthSignInTxt]="'PDP_UNAUTH_SIGN_IN_TXT' | translate" [openAltTxt]="'SEE_OPEN_ALT_TXT' | translate" 
        [isV2]="content?.product?.templates?.pdpDesign" ></web-shop-unauth-error-sticky>
      <div *ngFor="let component of content.product.templates.components" [style.order]="component.order">
        
        <intro-graphic-gm-web-shop *ngIf="component.type === 'INTRO_GRAPHIC'" [introGraphicContent]="component"
          theme="{{ bml.brand }}" [pricingData]="pricingData"
          [isAuthenticated]="(userState$ | async) === 'authenticated'" 
          [connectedByOnstarAltTxt]="'CONNECTED_BY_ONSTAR_ALT_TXT' | translate">
        </intro-graphic-gm-web-shop>

        <!-- TODO: Update Buy Now loading state to allow for closing downgrade modal -->
        <plan-pricing-gm-web-shop (buyNowEmitter)="buyNow($event)" [isCheckoutRedesignEnabled]="isCheckoutRedesignEnabled"
          *ngIf="component.type === 'PRICING'" [planId]="planId" [pricingData]="pricingData"
          [errorMessageDetail]="errorMessageDetail" [isAuthenticated]="(userState$ | async) === 'authenticated'"
          theme="{{ bml.brand }}" [buyFeatureTxt]="'PDP_PRICING_BUY_FEATURE_BTN_TXT' | translate"
          [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate"
          [loadingAltTxt]="'PDP_LOADING_ALT_TXT' | translate" [unauthSignInLnk]="'PDP_UNAUTH_SIGN_IN_LNK' | translate"
          [unauthSignInTxt]="'PDP_UNAUTH_SIGN_IN_TXT' | translate" [pricingContent]="component"
          [activateNowCMSKey]="'PDP_ACTIVATE_NOW' | translate" [seeAvailableProductsCMSKey]="'PDP_SEE_AVAILABLE_PRODUCTS' | translate"
          [connbystarIconAltTxt]="'ONSTAR_ICON_ALT_TXT' | translate" [renewalFrequencyTax]= "'renewal_frequency_tax' | translate"
          [isBuyNowLoading]="isBuyNowLoading" 
          [showMessage]="oldPlan && newPlan ? cmsText: ''"
          ></plan-pricing-gm-web-shop>
        <section-intro-gm-web-shop *ngIf="component.type === 'SECTION_INTRO'" [sectionContent]="component"
          product-name="TRAX" theme="{{ bml.brand }}" [seeDisclosureLbl]="'PDP_SEE_DISCLOSURES_MODAL_LNK' | translate"
          [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate">
        </section-intro-gm-web-shop>
        
        <feature-table-new-gm-web-shop 
          *ngIf="component.type === 'FEATURE_TABLE' && featureList && featureListLength > 0"
          [featureList]="featureList"
          [featureListLength]="featureListLength"
          (buyNowEmitter)="buyNow($event)"
          [pricingData]="pricingData"
          theme="{{ bml.brand }}"
          plan="MONTHLY"
          [aemOnstarURL]="aemOnstarURL"
          [errorMessageDetail]="errorMessageDetail"
          [productBlock]="component"
          [compareData]="compareData"
          [authState]="(userState$ | async) === 'authenticated'"
          [connServicesTabLbl]="'PDP_FEATURE_TBL_CONN_SERVICES_TAB_LBL' | translate"
          [tabOnstarLbl]="'PDP_FEATURE_TBL_ONSTAR_TAB_LBL' | translate"
          [compareAllPlansLbl]="'PDP_FEATURE_TBL_COMPARE_ALL_PLANS_BTN_TXT' | translate"
          [loadingAltTxt]="'PDP_LOADING_ALT_TXT' | translate" [openAltTxt]="'PDP_SEE_OPEN_ALT_TXT' | translate"
          [comparePlanReturnLbl]="'PDP_CMPR_PLN_RETURN_LBL' | translate"
          [comparePlansReturnToFeaturesTxt]="'PDP_CMPR_PLN_RTRN_TO_FEATURES_ALT_TXT' | translate"
          [comparePlansPlansPricingLbl]="'PDP_CMPR_PLN_PLANS_PRICING_LBL' | translate"
          [comparePlansSelectPlanLbl]="'PDP_CMPR_PLN_SELECT_PLAN_LBL' | translate"
          [comparePlansViewDetailsLbl]="'PDP_CMPR_PLN_VIEW_DETAILS_LBL' | translate"
          [planCode]="planCode"
          [showComparePlansButton]="showComparePlansButton"
          [interimCatalogEnabled]="isInterimCatalogEnabled">
        </feature-table-new-gm-web-shop>

        <single-feature-card-gm-web-shop *ngIf="component.type === 'FEATURE_CARD'"
          [singleFeatureCardContent]="component" theme="{{ bml.brand }}"
          [seeDisclosureLbl]="'PDP_SEE_DISCLOSURES_MODAL_LNK' | translate"
          [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate">
        </single-feature-card-gm-web-shop>

        <grouped-feature-card-gm-web-shop *ngIf="component.type === 'GROUPED_FEATURE_CARD'"
          [groupFeatureCardContent]="component" theme="{{ bml.brand }}"
          [seeDisclosureLbl]="'PDP_SEE_DISCLOSURES_MODAL_LNK' | translate"
          [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate">
        </grouped-feature-card-gm-web-shop>

        <grouped-feature-card-with-image-gm-web-shop *ngIf="component.type === 'GROUPED_FEATURE_CARD_IMAGE'"
          [groupFeatureCardImageContent]="component" theme="{{ bml.brand }}"
          [seeDisclosureLbl]="'PDP_SEE_DISCLOSURES_MODAL_LNK' | translate"
          [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate">
        </grouped-feature-card-with-image-gm-web-shop>

        <super-cruise-map-gm-web-shop *ngIf="component.type === 'SC_MAP'" [superCruiseMapContent]="component.content"
          theme="{{ bml.brand }}" [isV2]="component?.isV2">
        </super-cruise-map-gm-web-shop>

        <faq-gm-web-shop *ngIf="component.type === 'FAQ'" [faqContent]="component.content" product-name="TRAX"
          theme="{{ bml.brand }}" [faqImgAltTxt]="'FAQ_IMG_ALT_TXT'">
        </faq-gm-web-shop>

        <you-may-also-like-gm-web-shop *ngIf="component.type === 'YMAL'" theme="{{bml.brand}}" [planId]="planCode"
          [vin]="activeVehicle?.vin" [authState]="(userState$ | async) === 'authenticated'"
          [errorMessageDetail]="errorMessageDetail" [isV2]="component?.isV2">
        </you-may-also-like-gm-web-shop>

        <content-block-gm-web-shop *ngIf="component.type === 'CONTENT_BLOCK'" [contents]="component"
          [theme]="bml.brand" [disclosureLabel]="'PDP_DISCLOSURE_LBL' | translate" [gotItBtnTxt]="'PDP_SEE_GOT_IT_BTN_TXT' | translate">
        </content-block-gm-web-shop>

        <shop-social-proof-gm-web-shop *ngIf="component.type === 'SOCIAL_PROOF'" [socialProofContent]="component"
          [theme]="bml.brand" [isAuthenticated]="(userState$ | async) === 'authenticated'" [nxtsocialProofAltTxt]="'SOCIAL_PROOF_NEXT_ALT_TXT' | translate" 
          [prevsocialProofAltTxt]="'SOCIAL_PROOF_PREVIOUS_ALT_TXT' | translate">
        </shop-social-proof-gm-web-shop>

        <compare-plan-preview-dlp *ngIf="component.type === 'COMPARE_PREVIEW'" [comparePlanPreviewContent]="component"
          theme="{{ bml.brand }}" [vin]="activeVehicle?.vin"
          [isAuthenticated]="(userState$ | async) === 'authenticated'" 
          [comparePlansPlanExistsAltTxt]="'CMPR_PLN_PLAN_EXISTS_ALT_TXT' | translate" 
          [comparePlansPlanNotExistsAltTxt]="'CMPR_PLN_PLAN_NOT_EXIST_ALT_TXT' | translate"
          [isInterimCatalogEnabled]="isInterimCatalogEnabled">
        </compare-plan-preview-dlp>

        <product-card-section-gm-web-shop *ngIf="component.type === 'PRODUCT_CARD'" [productBlock]="component"
          [brand]="bml.brand" pageType="pageType">
        </product-card-section-gm-web-shop>

        <a-la-carte-section-gm-web-shop *ngIf="component.type === 'A_LA_CARTE'" [productBlock]="component"
          [brand]="bml.brand" [renewalFrequencyTax]= "'renewal_frequency_tax' | translate" pageType="pageType">
        </a-la-carte-section-gm-web-shop>

        <feature-highlight-grid-dlp *ngIf="component.type === 'FEATURE_HIGHLIGHT_GRID'"
          [featureHighlightGridContent]="component" [theme]="bml.brand">
        </feature-highlight-grid-dlp>

        <data-visualization-spotlight-gm-web-shop *ngIf="component.type === 'DATA_VISUALIZATION'" [content]="component"
          [theme]="bml.brand">
        </data-visualization-spotlight-gm-web-shop>

        <quote-spotlight-gm-web-shop *ngIf="component.type === 'QUOTE_SPOTLIGHT'"
          [content]="component" [theme]="bml.brand">
        </quote-spotlight-gm-web-shop>

        <shop-home-button-gm-web-shop *ngIf="component.type === 'BUTTON_COMPONENT'" [brand]="bml.brand"
          [headline]="component.content.copy.headline" [bodyCopy]="component.content.copy.bodyCopy"
          [buttonText]="component.content.copy.ctaCopy" [alignment]="component.alignment"
          [destination]="'/ownercenter/onstar/' + component.content.copy.ctaDestination | link"
          [trackingInfo]="':Plan Details:Button:Click:shop home'" (click)="trackingService.fireProp10Tracking(
          'Shop:' + pageNameService.getPageName() + ':Plan Details:Button:Click:shop home','Shop','')"
          aria-role="button">
        </shop-home-button-gm-web-shop>

        <multi-column-gm-web-shop (buyNowEmitter)="buyNow($event)" *ngIf="component.type === 'MULTI_COLUMN'" theme="{{bml.brand}}"
          [authState]="(userState$ | async) === 'authenticated'" [multiColumnContent]="component">
        </multi-column-gm-web-shop>

      </div>
    </div>
  </ng-container>
</ng-container>